<template>
  <div v-bind:class="{modal: true, hide: isHide}">
    <div class="box modalContent">
      <a @click="close" class="close">
        <img width="20px" src="../assets/times-solid.svg"/>
      </a>
      <h3>{{title}}</h3>
      <p>
        {{text}}
      </p>
      <a v-if="!tweet" class="btn" @click="close">{{btn}}</a>
      <a v-if="tweet" class="btn" @click="close" v-bind:href="'http://twitter.com/intent/tweet?url=https://point.pitaco.in/&text=' + tweet + '&hashtags=ぴたコイン'">{{btn}}</a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'modal',
  props: [
    'title',
    'text',
    'btn',
    'tweet',
    'active'
  ],
  data () {
    return {
      isHide: true
    }
  },
  created: function () {
  },
  methods: {
    close: function () {
      this.isHide = true
      this.$emit('close')
    }
  },
  watch: {
    active: function (val) {
      this.isHide = !val
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .modal{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  .modalContent{
    background: #fff;
    width: 90%;
    max-width: 450px;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 20px;
    margin: 0 auto;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  a{
    text-decoration: none;
  }
  .btn{
    background: #02BAD2;
    color: #fff;
    width: 90%;
    max-width: 360px;
    height: 60px;
    border-radius: 30px;
    line-height: 60px;
    margin: 10px auto 20px;
    font-weight: bold;
    display: block;
    cursor: pointer;
  }
  .close{
    background: #444;
    position: absolute;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    right: -5px;
    top: -5px;
  }
  .hide{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue